import { isTopic } from '@tunein/web-common';
import PropTypes from 'prop-types';
import { useStores } from 'src/common/providers';
import FavoriteControlWithOptions from './FavoriteControlWithOptions';
import { FavoriteIconControl } from './FavoriteIconControl';

export function FavoriteControl({
  profileGuideItem,
  fill,
  hoverFill,
  showIconLabel,
  iconClassName,
  unFavoritedClassName,
}) {
  const { playerStore } = useStores();
  const tunedGuideItem = playerStore.currentGuideItem();
  const tunedGuideId = tunedGuideItem?.playableGuideId;
  const profilePlayableGuideId = profileGuideItem?.actions?.play?.guideId;
  let showControlWithOptions = !profilePlayableGuideId && isTopic(tunedGuideId);

  if (profilePlayableGuideId) {
    const tunedGuideItemParentId = tunedGuideItem?.parentGuideId;
    const profileGuideItemParentId = profileGuideItem?.parentGuideId;

    const hasMatchingParents =
      Boolean(tunedGuideItemParentId && profileGuideItemParentId) &&
      tunedGuideItemParentId === profileGuideItemParentId;

    showControlWithOptions = hasMatchingParents && isTopic(profilePlayableGuideId);
  }

  return showControlWithOptions ? (
    <FavoriteControlWithOptions
      guideItem={profileGuideItem}
      showIconLabel={showIconLabel}
      fill={fill}
      iconClassName={iconClassName}
      unFavoritedClassName={unFavoritedClassName}
    />
  ) : (
    <FavoriteIconControl
      guideItem={profileGuideItem}
      fill={fill}
      hoverFill={hoverFill}
      showIconLabel={showIconLabel}
      iconClassName={iconClassName}
      unFavoritedClassName={unFavoritedClassName}
    />
  );
}

FavoriteControl.propTypes = {
  profileGuideItem: PropTypes.object,
  fill: PropTypes.string,
  hoverFill: PropTypes.string,
  iconClassName: PropTypes.string,
  showIconLabel: PropTypes.bool,
  unFavoritedClassName: PropTypes.string,
};
